import { useState, useEffect } from 'react';

import { useBreakpoints } from '@/hooks/use-breakpoints';

/**
 * Хук возвращает состояние скролла фиксированного
 * хедера для определения его высоты на странице.
 * @returns {{ isHeaderScrolled: boolean }}
 */
export const useHeaderScroll = () => {
  const { isComputed, desktop, tablet } = useBreakpoints();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (!isComputed || !(desktop || tablet)) {
      return;
    }

    const updateScrollState = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', updateScrollState, { passive: true });
    updateScrollState();

    return () => window.removeEventListener('scroll', updateScrollState);
  }, [isComputed, desktop, tablet]);

  return { isHeaderScrolled: isScrolled };
};
